export default {"src":"/_next/static/media/badge-google-zh.92de90fb.svg","height":41,"width":135,"blurWidth":0,"blurHeight":0};